const initialState = false;

const showUnsortedPanelReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_UNSORTED_PANEL':
            return !state;
        default:
            return state;
    }
};

export default showUnsortedPanelReducer;
